import { useEffect, useState } from "react";
import AdminLayout from "@/components/admin/AdminLayout";
import { adminApi } from "@/lib/api";

export default function AdminPayouts() {
  const [items, setItems] = useState([]);
  useEffect(() => { adminApi.get("/admin/payouts").then((r) => setItems(r.data)); }, []);

  return (
    <AdminLayout>
      <div className="p-8">
        <h1 className="text-3xl font-extrabold">Payouts</h1>
        <p className="text-slate-500 mt-1">{items.length} payouts on record</p>
        <div className="mt-6 bg-white rounded-xl shadow-sm border border-slate-200 overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-xs uppercase text-slate-400 border-b border-slate-100">
              <tr><th className="text-left py-3 px-4">Submission</th><th>Amount</th><th>Method</th><th>Status</th><th>Date</th></tr>
            </thead>
            <tbody>
              {items.map((p) => (
                <tr key={p.id} className="border-b border-slate-50">
                  <td className="py-3 px-4 font-mono text-xs">{p.submission_id.slice(0,10)}…</td>
                  <td className="font-bold">${p.amount?.toFixed(2)}</td>
                  <td>{p.method}</td>
                  <td><span className="px-2 py-0.5 rounded-full text-xs font-bold bg-slate-100">{p.status}</span></td>
                  <td className="text-xs text-slate-500">{new Date(p.created_at).toLocaleString()}</td>
                </tr>
              ))}
              {!items.length && <tr><td colSpan={5} className="py-10 text-center text-slate-400">No payouts yet</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </AdminLayout>
  );
}
